var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nt-loadingbar",style:({width:_vm.progressVal+'%',backgroundColor:_vm.barColor,opacity:_vm.opcy})})}
var staticRenderFns = []

export { render, staticRenderFns }